import React from 'react';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import useMediaQuery from '../../hooks/useMediaQuery';

/**
 * FilterReset
 *
 * A DWT reusable component
 *
 * @param {Object} props
 * @param {Object} props.setStart
 * @param {string} props.contextFilter
 * @param {string} props.dataFilter
 */
const FilterResetButton = ({ setStart, checked, setChecked, dataFilter, scrollToTop, initialObj }) => {
  const isDesktop = useMediaQuery( '( min-width: 1024px )' );
  const handleResetButton = ( e ) => {
    if ( !checked ) return;
    setStart( 0 );
    e.target.closest( '.inner-blocks-wrapper' ).removeAttribute( dataFilter );
    setChecked( typeof ( checked ) === 'object' && !isEmpty( initialObj ) ? initialObj : typeof ( checked ) === 'object' && isEmpty( initialObj ) ? {} : '' );
    scrollToTop();
  };

  return (
    <button
      className={ `filters__btn--reset btn--secondary border border-solid p-5 text-12 self-end w-max-content ml-auto my-15 ${!isDesktop ? 'invisible max-h-0' : ''} ${!!( !checked || isEmpty( checked ) || isEqual( checked, initialObj ) ) ? 'opacity-30' : ''}` }
      type='button'
      onClick={ handleResetButton }
      disabled={ !!( !checked || isEmpty( checked ) || isEqual( checked, initialObj ) ) }
    >
      reset
    </button>
  );
};

export default FilterResetButton;
